module.exports = __webpack_public_path__ + "img/ea80888.jpg";